import { memo } from "react";

import { baseStyles } from "@react/sections/BentoBox/BentoBoxCard/BentoBoxCard.styles";
import {
  type BentoBoxCardProps,
  type BentoBoxCardAlignX,
  type BentoBoxCardAlignY,
  type BentoBoxCardContentWidthPercentage,
} from "@root/tablescape/state/bentoBox";
import { tw, type TTailwindString } from "classnames";

const styles = {
  base: ({
    alignX,
    alignY,
    className,
  }: {
    alignX: BentoBoxCardAlignX;
    alignY: BentoBoxCardAlignY;
    className?: TTailwindString;
  }) =>
    tw(
      baseStyles.base({ alignX, alignY, className }),
      "rounded",
      "bg-placeholder"
    ),
  content: ({
    alignX,
    contentWidthPercentage,
  }: {
    alignX: BentoBoxCardAlignX;
    contentWidthPercentage: BentoBoxCardContentWidthPercentage;
  }) => tw(baseStyles.content({ alignX, contentWidthPercentage })),
};

const BentoBoxCardPlaceholderBase = ({
  alignX = "left",
  alignY = "bottom",
  className,
  contentWidthPercentage,
}: BentoBoxCardProps & { className?: TTailwindString }) => {
  return (
    <div
      className={tw(
        styles.base({ alignX, alignY, className }),
        "rounded",
        "bg-placeholder"
      )}
    >
      <div
        className={styles.content({
          alignX,
          contentWidthPercentage,
        })}
      ></div>
    </div>
  );
};

export const BentoBoxCardPlaceholder = memo(BentoBoxCardPlaceholderBase);
